import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";
import { SUPPORTED_LANGUAGES } from "@/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

/** Strict language → country flag pairing */
const LANG_FLAGS: Record<string, string> = {
  en: "🇺🇸",
  ar: "🇸🇦",
  fr: "🇫🇷",
  es: "🇪🇸",
};

export function LanguageSelector() {
  const { i18n, t } = useTranslation();

  const currentLang =
    SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language) ||
    SUPPORTED_LANGUAGES[0];
  const currentFlag = LANG_FLAGS[currentLang.code] || "🌍";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="flex items-center gap-1.5 px-2 py-1.5 text-muted-foreground hover:text-foreground transition-colors rounded-lg hover:bg-secondary/50"
          title={t("language.select")}
        >
          <span className="text-base leading-none">{currentFlag}</span>
          <span className="text-xs font-medium hidden sm:inline">
            {currentLang.label}
          </span>
          <ChevronDown className="h-3 w-3 opacity-50" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            className={i18n.language === lang.code ? "bg-accent font-semibold" : ""}
          >
            <span className="mr-2">{LANG_FLAGS[lang.code] || "🌍"}</span>
            <span className={lang.dir === "rtl" ? "font-arabic" : ""}>
              {lang.label}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
